"use strict";

angular
    .module("internal.exams")
    .controller("InternalExamAutomationAlertTypes", [
        "$scope",
        "EXAlertTypes",
        "$rootScope",
        "Resource",
        "Cache",
        function($scope, EXAlertTypes, $rootScope, Resource, Cache) {
            $scope.loading = true;

            EXAlertTypes.get().then(function(AlertTypes) {
                $scope.AlertTypes = AlertTypes;
                $scope.loading = false;
            });

            $scope.columns = [
                {
                    label: "Name",
                    field: "name",
                    link: {
                        state: "internal.exams.administrative.alerttype",
                        params: [
                            {
                                name: "examAlertTypeID",
                                field: "id"
                            }
                        ]
                    }
                },

                {
                    label: "Default Alert Message",
                    field: "message"
                },

                {
                    label: " Allow Duplicate",
                    field: "allow_duplicates",
                    type: "yesno"
                },

                {
                    label: "Last Modified",
                    field: "modifiedon",
                    type: "datetime"
                },

                {
                    label: "Modified By",
                    field: "modifiedby"
                }
            ];
        }
    ]);
